export default __webpack_public_path__ + "static/smoke_detector_w.8e0b93df167198c01c3680a297497ee6.svg";